"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEventState = void 0;
var ProducerEventState;
(function (ProducerEventState) {
    ProducerEventState["NotStarted"] = "NotStarted";
    ProducerEventState["InProgress"] = "InProgress";
    ProducerEventState["ForReview"] = "ForReview";
    ProducerEventState["ReadyToPublish"] = "ReadyToPublish";
    ProducerEventState["Published"] = "Published";
})(ProducerEventState = exports.ProducerEventState || (exports.ProducerEventState = {}));
//# sourceMappingURL=producer-event-state.js.map